import { useState } from "react";
import { FaCog, FaChartLine, FaFileImport, FaCloudUploadAlt } from "react-icons/fa";
import GeneralConfig from "./GeneralConfig";
import IndicesTab from "../Indices/Indices";
import ImportTab from "../ImportContratos/ImportContratos";
import DataMigration from "./DataMigration";

const TABS = [
  { key: "general", label: "General", icon: FaCog },
  { key: "indices", label: "Indices", icon: FaChartLine },
  { key: "importar", label: "Importar Excel", icon: FaFileImport },
  { key: "datos", label: "Datos / Backup", icon: FaCloudUploadAlt },
];

function AlquileresConfig() {
  const [tab, setTab] = useState("general");

  return (
    <div className="px-4 md:px-6 py-4 space-y-4">
      <h1 className="text-2xl font-bold text-gray-800 dark:text-gray-100">
        Configuracion
      </h1>

      {/* Tabs */}
      <div className="flex gap-1 border-b border-gray-200 dark:border-gray-700">
        {TABS.map((t) => {
          const Icon = t.icon;
          const active = tab === t.key;
          return (
            <button
              key={t.key}
              onClick={() => setTab(t.key)}
              className={`inline-flex items-center gap-2 px-4 py-2.5 text-sm font-medium border-b-2 transition-colors -mb-px ${
                active
                  ? "border-primary text-primary"
                  : "border-transparent text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-200 hover:border-gray-300"
              }`}
            >
              <Icon className="w-4 h-4" />
              {t.label}
            </button>
          );
        })}
      </div>

      {/* Tab content */}
      {tab === "general" && <GeneralConfig />}
      {tab === "indices" && <IndicesTab embedded />}
      {tab === "importar" && <ImportTab embedded />}
      {tab === "datos" && <DataMigration />}
    </div>
  );
}

export default AlquileresConfig;
